export const environment = {
  production: true,
  authServiceUrl: 'https://ir2.internal.sparbankensyd.se/service',
  irApiUrl: 'https://ir2.internal.sparbankensyd.se/api',
  domain: 'ir2.internal.sparbankensyd.se',
  testMode: false
}